import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// @material-ui/icons
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { Link } from "react-router-dom";

import GridContainer from "components/Grid/GridContainer.js";
import CardBody from "components/Card/CardBody.js";
import MobileWrapper from "componentsCustom/Mobile/MobileWrapper.js";
import AddItem from "componentsCustom/AddItem/AddItem.js";
import MenuTypeTimetableContainer from "container/componentsCustom/MenuTypeTimetableContainer.js";
import Item from "componentsCustom/ListItem/Item";
import CalendarAlert from "componentsCustom/Calendar/CalendarAlert.js";

import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

// import articoli from "api/articoli.json";

const useStyles = makeStyles(menuStyle);

export default function BaseItemList(props) {
  const {
    updateCart,
    cart,
    language,
    museum,
    currency,
    customStyle,
    updateShippingInfo,
    // updateCartParams,
    shippingInfo,
    cartParams,
    articles,
  } = props;

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const [list, setList] = useState([]);
  const [, setCategories] = useState([]);

  const [showAddItem, setShowAddItem] = useState(false);
  const [selectItem, setSelectedItem] = useState({});
  const [showAlert, setShowAlert] = useState(true);
  const [openings, setOpenings] = useState({});

  const [isOpen] = useState("");

  useEffect(() => {
    if (articles && articles[0] && articles.length > 0) {
      const categoriesArray = articles.map((el) => {
        return {
          codici_sconto: el.codici_sconto,
          id: el.id,
          nome_categoria: el.nome_categoria,
        };
      });

      setList(articles);
      setCategories(categoriesArray);
    }
  }, [articles]);

  useEffect(() => {
    if (museum && museum.orari_museo) {
      setOpenings(museum.orari_museo);
    }
  }, [museum]);

  useEffect(() => {
    if (shippingInfo && shippingInfo.date) {
      setShowAlert(false);
    }
  }, [shippingInfo]);

  // console.log("Shipping info", shippingInfo);

  const classes = useStyles();

  const { t } = useTranslation();

  const [alertProps] = useState({
    title: t("select_date_title"),
    description: t("select_date_description"),
    showConfirm: true,
  });

  function openSweetAlert(item, category, index, timetable) {
    setShowAddItem(true);
    setSelectedItem(
      Object.assign({}, item, { category: category, index, timetable })
    );
  }

  function addToCart(item, quantity, ingredientC, additionalKey, note, hg) {
    // console.log("STO AGGIUNGENDO A CARRELLO", {
    //   item,
    //   quantity,
    //   ingredientC,
    //   additionalKey,
    //   note,
    //   hg
    // });
    // AGGIUNGI A CARRELLO

    if (item && item.id) {
      if (cart && Array.isArray(cart)) {
        const copyCart = [].concat(cart);

        /* ***********************************************************
        POSSO CALCOLARE L'ID DELLE AGGIUNTE ANDANDO A DIVIDERE ADDITIONALKEY
        ADDITIONALKEY È COMPOSTO DA -->
        $(HG)${TYPE}_${ID_AGGIUNTA}_${ID_ITEM_AGGIUNTA}(${QUANTITY})/...
        ********************************************************** */
        let maxObj = {};
        let maxNumber = 0;
        const allAdd = additionalKey.split("/");

        allAdd.forEach((element) => {
          const [, id] = element.split("_");
          const findEl =
            item && item.add && item.add.find((el) => el._id === id);

          if (findEl && findEl.maxNumber) {
            maxNumber = findEl.maxNumber;
            maxObj = Object.assign({}, maxObj, { [id]: maxNumber });
          }
        });

        // console.log(" LA SEPARAZIONE è", { allAdd, maxNumber, maxObj });

        if (copyCart && copyCart.length > 0) {
          // CERCO SE QUEL BIGLIETTO è GIA' PRESENTE NEL CARRELLO
          // CONTROLLO ANCHE SE AL BIGLIETTO SONO STATE FATTE DELLE MODIFICHE
          // QUESTA FUNZIONE PER LE MODIFICHE ATTUALMENTE NON VIENE USATA

          const findIndexEl = cart.findIndex(
            (el) =>
              el.productId === item.id && el.additionalKey === additionalKey
          );

          if (findIndexEl >= 0) {
            // SE IL BIGLIETTO ESISTE GIA'

            // SE IL BIGLIETTO ESISTE GIA' AUMENTO LA QUANTITA'
            copyCart[findIndexEl].quantity += quantity || 1;
          } else {
            // SE IL BIGLIETTO NON ESISTE LO METTO NEL CARRELLO
            copyCart.push({
              item: item,
              quantity: quantity,
              price: !Number.isNaN(Number(item.prezzo_articolo))
                ? Number(item.prezzo_articolo)
                : 0.0,
              productId: item.id,
              ingredientC,
              additionalKey,
              note,
              categoria_articolo: item.categoria_articolo,
              index: item.index,
              information: item.information || [],
            });
          }
        } else {
          copyCart.push({
            item: item,
            quantity: quantity,
            price: !Number.isNaN(Number(item.prezzo_articolo))
              ? Number(item.prezzo_articolo)
              : 0.0,
            productId: item.id,
            ingredientC,
            additionalKey,
            note,
            categoria_articolo: item.categoria_articolo,
            index: item.index,
            information: [
              /* *****************************************
               IN QUESTO ARRAY VERRANNO SCRITTE LE INFORMAZIONI DI TUTTI I VISITATORI
               ***************************************** */
              // visitatore: {
              //   CAP: "",
              //   nazione: "",
              //   sesso: "",
              //   nascita: null,
              //   codice_biglietto: item.ticketId,
              //   flag_data_aperta: false,
              //   email: shippingInfo.email
              // },
            ],
          });
        }
        updateCart(copyCart);
      }
    }
  }

  const {
    // totalPrice,
    // servicesFees,
    // deliveryCost,
    // total,
    cartCounter,
    totToShow, // totalPrice + servicesFees + deliveryCost
    // vat
  } = cartParams;

  const componentsContent = (
    <CardBody style={{ marginTop: "20px" }}>
      {list && Object.keys(list) && Object.keys(list).length > 0 ? (
        <div>
          <MenuTypeTimetableContainer />
          {list.map((category) => {
            return (
              <div
                // style={{ backgroundColor: "red" }}
                key={category.id}
              >
                {/* <CardHeader> */}
                <div
                  onClick={() => {
                    // if (
                    //   matches &&
                    //   museum.delivery &&
                    //   museum.delivery.isListMenu
                    // ) {
                    //   if (el && el.categoria_articolo && el.categoria_articolo._id === isOpen) {
                    //     setIsOpen("");
                    //   } else {
                    //     setIsOpen(
                    //       el.categoria_articolo && el.categoria_articolo._id ? el.categoria_articolo._id : ""
                    //     );
                    //   }
                    // }
                  }}
                  style={
                    matches && museum.delivery && museum.delivery.isListMenu
                      ? {
                          // backgroundColor: "rgba(250,250,250,1)",
                          border: "solid 1px rgba(222,222,222,1)",
                          borderRadius: 10,
                          display: "table",
                          padding: "5px",
                          paddingBottom: "10px",
                          marginTop: "5px",
                          marginBottom: "5px",
                          width: "100%",
                        }
                      : {}
                  }
                >
                  <h1
                    className={classes.title}
                    style={{ float: "left", width: "calc(100% - 30px)" }}
                  >
                    {/* {el && el.categoria_articolo && el.categoria_articolo[`label_${language}`]
                      ? el.categoria_articolo[`label_${language}`].toUpperCase()
                      : ""} */}
                    {category.nome_categoria ? category.nome_categoria : ""}
                  </h1>
                  {matches && museum.delivery && museum.delivery.isListMenu ? (
                    <div
                      style={{
                        width: "30px",
                        textAlign: "center",
                        marginTop: "10px",
                        float: "left",
                      }}
                    >
                      {category &&
                      category.categoria_articolo &&
                      category.categoria_articolo._id === isOpen ? (
                        <ExpandLessIcon></ExpandLessIcon>
                      ) : (
                        <ExpandMoreIcon></ExpandMoreIcon>
                      )}
                    </div>
                  ) : null}
                </div>
                {/* </CardHeader> */}

                <GridContainer>
                  {category.articoli
                    ? category.articoli.map((item, ind) => {
                        return (
                          <Item
                            key={item.id}
                            item={item}
                            currency={currency}
                            language={language}
                            customStyle={customStyle}
                            category={category}
                            index={ind}
                            openSweetAlert={openSweetAlert}
                            addToCart={addToCart}
                            updateCart={updateCart}
                            cart={cart}
                          />
                        );
                      })
                    : null}
                </GridContainer>
              </div>
            );
          })}
        </div>
      ) : null}
    </CardBody>
  );

  function onCancel() {
    setSelectedItem({});
    setShowAddItem(false);
  }

  function onConfirm(item, quantity, ingredientC, note, hg) {
    // setSelectedItem({});
    // setShowAddItem(false);
    /* ******************************
     DEVO FARE IL SORT DI INGREDIENT C
    ******************************* */
    // console.log("ON CONFIRM IS", {
    //   item,
    //   quantity,
    //   ingredientC,
    //   note,
    //   hg
    // });

    const ordered = {};
    const copyIngredientC = JSON.parse(JSON.stringify(ingredientC));
    let additionalKey = ``;
    Object.keys(copyIngredientC)
      .sort()
      .forEach(function(key) {
        ordered[key] = copyIngredientC[key];
        additionalKey += key;
      });
    if (ordered) {
      Object.keys(ordered).forEach((e) => {
        function compare(a, b) {
          // Use toUpperCase() to ignore character casing
          const idA = a._id;
          const idB = b._id;

          let comparison = 0;
          if (idA > idB) {
            comparison = 1;
          } else if (idA < idB) {
            comparison = -1;
          }
          return comparison;
        }

        ordered[e].sort(compare);

        /* **********************************
        CREO ADDITIONALKEY PER SCOPRIRE SE LO
        STESSO ARTICOLO CON LE STESSE CORREZIONI
        DI UGUALE QUANTITÀ È GIÀ PRESENTE NEL
        CARRELLO --> SONO NECESSARI GLI ID PER
        OGNI ARTICOLO E PER OGNI CORREZIONE EFFETTUATA
        ************************************* */

        additionalKey += "";
      });
    }
    /* ******************************
     FINE SORT DI INGREDIENT C
    ******************************* */
    addToCart(item, quantity, ordered, additionalKey, note, hg);
    onCancel();
  }

  function getCustomAdd() {
    /* ***************************************************
    NEL CASO SI VOGLIA GESTIRE DELLE AGIUNTE CUSTOM
    **************************************************** */
    return [];
  }

  return (
    <>
      <MobileWrapper
        type={"contacts"}
        showButtons={!!(cartCounter && cartCounter > 0)}
        containerClasses={classes.transparentStyle}
        containerMobileButton={classes.containerMobileButtonMenu}
        buttons={[
          {
            onClick: () => {},
            color: "warning",
            text: t("cart.go_to_cart"),
            isActive: true,
            isLinkActive: true,
            path: `cart`,
            customStyle: { backgroundColor: customStyle.buttonCart },
            leftComponent: (
              <>
                {cartCounter ? (
                  <span style={{ verticalAlign: "super" }}>
                    <span className={classes.notifications}>
                      <span>{cartCounter}</span>
                    </span>
                  </span>
                ) : null}
              </>
            ),
            rightComponent: (
              <span className={classes.littlePrice}>
                {totToShow ? totToShow.toFixed(2) : ""}
                <span style={{ paddingRight: "2px", color: "white" }}>
                  {totToShow && currency && currency.symbol
                    ? currency.symbol
                    : ""}
                </span>
              </span>
            ),
          },
        ]}
      >
        <div style={{ marginTop: "40px" }}>
          <Link
            to={`/${museum.identificativo}/shop`}
            style={{ color: "#555555", fontSize: "20px" }}
          >
            Torna al museo
          </Link>
        </div>
        <div className="body_container">
          {museum.cover && museum.cover.url ? (
            <div
              // href="/list"
              // to={`/${museum.identificativo}/shop`}
              title={museum.nome}
              style={{
                width: "100%",
                backgroundImage: `url('${museum.cover.url}')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: "400px",
                display: "flex",
                alignItems: "center",
                padding: "30px",
                borderRadius: "10px",
                flexDirection: "column",
                justifyContent: "end",
                textShadow: "3px 2px 15px rgba(0,0,0,0.8)",
                textAlign: "left",
                marginTop: "50px",
              }}
            >
              <h1
                className={classes.title}
                style={{
                  marginBottom: "10px",
                  width: "100%",
                  fontSize: "30px",
                  color: museum.colore ? museum.colore : "#fff",
                }}
              >
                {/* {el && el.categoria_articolo && el.categoria_articolo[`label_${language}`]
                ? el.categoria_articolo[`label_${language}`].toUpperCase()
                : ""} */}
                {museum.nome}
              </h1>
              {museum.descrizione_museo ? (
                <div
                  style={{
                    // margin: "30px auto",
                    width: "100%",
                    fontSize: "24px",
                    margin: "0",
                    color: museum.colore ? museum.colore : "#fff",
                  }}
                >
                  {museum.descrizione_museo}
                </div>
              ) : null}
            </div>
          ) : null}
          {componentsContent}
        </div>
      </MobileWrapper>
      <AddItem
        language={language}
        currency={currency}
        showAlert={showAddItem}
        selectItem={selectItem}
        customStyle={customStyle}
        hasAddItem={true}
        showCancel={false}
        customIngredients={getCustomAdd()}
        hasNote={false}
        // hasRemoveIngredients={
        //   selectItem &&
        //   selectItem.categoria_articolo &&
        //   ID_PANINO === selectItem.categoria_articolo._id
        // }
        hasRemoveIngredients={
          selectItem &&
          selectItem.removableIngredients &&
          selectItem.removableIngredients.length > 0
        }
        title={
          selectItem && selectItem.nome_articolo
            ? selectItem.nome_articolo.toUpperCase()
            : ""
        }
        price={
          selectItem &&
          selectItem.prezzo_articolo &&
          !Number.isNaN(Number(selectItem.prezzo_articolo))
            ? Number(selectItem.prezzo_articolo)
            : 0
        }
        description={
          selectItem && selectItem.venditore_articolo ? (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                key={selectItem.id}
                className={"description"}
                style={{
                  float: "left",
                  marginRight: "2px",
                }}
              >
                {selectItem.venditore_articolo}
              </div>
            </div>
          ) : null
        }
        onConfirm={onConfirm}
        onCancel={() => {
          setSelectedItem({});
          setShowAddItem(false);
        }}
      />
      <CalendarAlert
        alertProps={alertProps}
        onCancel={() => {
          setShowAlert(false);
        }}
        showAlert={showAlert}
        openings={openings}
        // openings={{}}
        shippingInfo={shippingInfo}
        updateShippingInfo={updateShippingInfo}
        logo={
          museum && museum.logo_light && museum.logo_light.url
            ? museum.logo_light.url
            : ""
        }
        language={language}
      />
    </>
  );
}

BaseItemList.propTypes = {
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string,
  }).isRequired,
  articles: PropTypes.arrayOf(PropTypes.object).isRequired,
  shippingInfo: PropTypes.shape({
    type: PropTypes.string,
    timetable: PropTypes.object,
  }).isRequired,
  updateShippingInfo: PropTypes.func.isRequired,
  updateCartParams: PropTypes.func.isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    total: PropTypes.number,
    cartCounter: PropTypes.number,
    totToShow: PropTypes.number,
    vat: PropTypes.number,
  }).isRequired,
  updateCart: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  cart: PropTypes.arrayOf(PropTypes.object),
  museum: PropTypes.object,
  customStyle: PropTypes.object,
};

BaseItemList.defaultProps = {
  museum: null,
  customStyle: {},
};
